/**
 * @generated SignedSource<<cc0972082c39e6b34e68504f4af2f190>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpHeadDeprecated_viewer$data = {
  readonly isPdpUrlTranslationEnabled?: boolean | null;
  readonly " $fragmentType": "PdpHeadDeprecated_viewer";
};
export type PdpHeadDeprecated_viewer$key = {
  readonly " $data"?: PdpHeadDeprecated_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpHeadDeprecated_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpHeadDeprecated_viewer",
  "selections": [
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "isPdpUrlTranslationEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "translatedPdpUrls"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "078192fba0343d4057e1be791988c9cd";

export default node;
